import React from "react";
import { useGoogleRedirect } from "./useGoogleRedirect";
import { observer } from "mobx-react-lite";
import { useGlobalSupportedFeatureFeature } from "../core/views/SupportedFeatureSwitch";
import BouncingDotsLoader from "./Dots";
import styles from "./GoogleRedirect.module.scss";

const links = Object.freeze({
  integ: "https://integ.upsolver.com",
  local: "http://localhost:3000",
  prod: "https://app.upsolver.com",
  e2e: "https://e2e.upsolver.com",
});

function oldAppDeploymentLinks(deployment: string) {
  const link = links[deployment as keyof typeof links];
  if (link == null) {
    throw Error(`Bad deployment name: ${deployment}`);
  }
  return link;
}

const redirectUrl = () => {
  const url = new URL(oldAppDeploymentLinks(process.env.REACT_APP_ENV_TYPE));
  url.search = window.location.search;
  url.pathname = window.location.pathname;
  return url.toString();
};

type GoogleRedirectButtonProps = { invitationId?: string; supportsKnownClients?: boolean };
const GoogleRedirectButton = observer(({ invitationId, supportsKnownClients }: GoogleRedirectButtonProps) => {
  const { loginUri, invitationUri, state } = useGoogleRedirect(redirectUrl(), supportsKnownClients, invitationId);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: 8 }}>
      <div
        id="g_id_onload"
        data-client_id="89754441866-b76mt1p19ju8vs4aac7otqb0kgc007oq.apps.googleusercontent.com"
        data-context="signin"
        data-ux_mode="redirect"
        data-login_uri={invitationUri ?? loginUri}
        data-auto_prompt="false"
      />
      <div
        className="g_id_signin"
        data-type="standard"
        data-shape="pill"
        data-theme="outline"
        data-text="signin_with"
        data-size="large"
        data-logo_alignment="left"
        data-state={state}
      />
    </div>
  );
});

const Placeholder = React.memo(() => {
  return (
    <div className={styles.Placeholder}>
      <div className={styles.content}>
        <BouncingDotsLoader ballColors={["#EA4335", "#FBBC05", "#34A853", "#4285F4"]} />
      </div>
    </div>
  );
});

const Wrapper = ({ invitationId }: Pick<GoogleRedirectButtonProps, "invitationId">) => {
  const supportsKnownClients = useGlobalSupportedFeatureFeature("known-clients");
  console.log("supportsKnownClients", supportsKnownClients);
  if (supportsKnownClients === "loading") {
    return <Placeholder />;
  } else {
    return <GoogleRedirectButton invitationId={invitationId} supportsKnownClients={false} />;
  }
};

export default Wrapper;
